// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"53bd0860","453":"5c7165bf","454":"3dcf6e75","702":"56ecc9d6"}[chunkId] + ".chunk.js";
};